<template>
  <v-app>
    <dashboard-core-app-bar />

    <dashboard-core-drawer />

    <dashboard-core-view />

    <dashboard-core-settings />
  </v-app>
</template>

<script>
export default {
  name: 'DashboardIndex',

  components: {
    DashboardCoreAppBar: () => import('./AppBar'),
    DashboardCoreDrawer: () => import('./Drawer'),
    DashboardCoreSettings: () => import('./Settings'),
    DashboardCoreView: () => import('./View')
  },

  data: () => ({
    expandOnHover: false
  })
}
</script>
